import React from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Heading } from "./UI/Typoraphy";
import { mq } from "./responsive";

export const Section = React.forwardRef(
  ({ heading, children, style, ...props }, ref) => {
    return (
      <section
        css={{
          position: "relative",
          padding: "6rem 4rem 4rem",

          [mq.xl]: {
            padding: "12rem 15rem 12rem",
          },

          ...style,
        }}
        {...props}
        ref={ref}
      >
        {heading && (
          <Heading
            style={{
              ...heading.style,
            }}
            level={2}
          >
            {heading.content}
          </Heading>
        )}
        {children}
      </section>
    );
  }
);

export const Container = ({ children, style, fluid, ...props }) => {
  return (
    <div
      css={{
        padding: "0rem 4rem",

        [mq.xl]: {
          padding: "0rem 15rem",
        },

        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export const Grid = ({
  children,
  gutter: { xs = 8, sm = xs, md = sm, lg = md, xl = lg } = {},
  style,
  ...props
}) => {
  return (
    <div
      css={{
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "wrap",
        msOverflowStyle: "none",
        scrollbarWidth: 0,
        marginBottom: "1rem",
        margin: `0 ${-xs / 2}px`,
        width: `calc(100% + ${xs / 2})`,

        "& > div": {
          padding: `${xs / 2}px`,
        },

        [mq.sm]: {
          margin: `0 ${-sm / 2}px`,
          width: `calc(100% + ${sm / 2})`,
          "& > div": {
            padding: `${sm / 2}px`,
          },
        },

        [mq.md]: {
          margin: `0 ${-md / 2}px`,
          width: `calc(100% + ${md / 2})`,
          "& > div": {
            padding: `${md / 2}px`,
          },
        },

        [mq.lg]: {
          margin: `0 ${-lg / 2}px`,
          width: `calc(100% + ${lg / 2})`,
          "& > div": {
            padding: `${lg / 2}px`,
          },
        },

        [mq.xl]: {
          margin: `0 ${-xl / 2}px`,
          width: `calc(100% + ${xl / 2})`,
          "& > div": {
            padding: `${xl / 2}px`,
          },
        },

        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export const Col = ({
  children,
  style,
  span: { xs = 4, sm = xs, md = sm * 3, lg = md, xl = lg } = {},
  ...props
}) => {
  return (
    <div
      css={{
        width: `${(xs / 4) * 100}%`,

        [mq.sm]: {
          width: `${(sm / 4) * 100}%`,
        },

        [mq.md]: {
          width: `${(md / 12) * 100}%`,
        },

        [mq.lg]: {
          width: `${(lg / 12) * 100}%`,
        },

        [mq.xl]: {
          width: `${(xl / 12) * 100}%`,
        },
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
};
